import Ajax from './ajax'
import axios  from '../plugins/axios'
import {
    ApiPopular,
    ApiCatalog,
    ApiNovelties,
    ApiViewMod,
    ApiModsSimilar,
    ApiDownloadMod,
    ApiTopViewsWeek, ApiTopDownloadsWeek, ApiVersions, ApiCatalogSearch, ApiModVideo
} from '@/const'

export default {
    getAllMods(data: any, success: any) {
      Ajax.get(ApiCatalog, data, success, () => false)
    },
    searchMod(data: any, success: any) {
        Ajax.get(ApiCatalogSearch, data, success, () => false)
    },
    getCatalogMods(data: any, success: any) {
        Ajax.get(ApiCatalog, data, success, () => false)
    },
    getPopularMods(data: any, success: any) {
        Ajax.get(ApiPopular, data, success, () => false)
    },
    deleteMod(data: {mod_id: number}, success: any, failure: any) {
        Ajax.delete(ApiCatalog+'/'+data.mod_id, success, failure)
    },
    getNoveltyMods(data: any, success: any) {
        Ajax.get(ApiNovelties, data, success, () => false)
    },
    getModBySlug(data: {slug: string | string[], l: boolean | undefined}, success: any, failure: any) {
        if(data.l) {
            Ajax.get(ApiCatalog + '/' + data.slug, {l: data.l}, success, failure)
        } else {
            Ajax.get(ApiCatalog + '/' + data.slug, {}, success, failure)
        }
    },
    addModVersion(data: any, success: any, failure: any) {
        Ajax.post(ApiVersions, data, success, failure)
    },
    incrementModViews(data: {slug: string | string[]}, success: any, failure: any) {
        Ajax.post(ApiViewMod, data, success, failure)
    },
    incrementModDownloads(data: {id: number}, success: any) {
        Ajax.post(ApiDownloadMod, data, success, () => false)
    },
    getSimilarMods(data: {game: string}, success: any) {
        Ajax.get(ApiModsSimilar, data, success, () => false)
    },
    getTopViewsWeekMods(success: any) {
        Ajax.get(ApiTopViewsWeek, {}, success, () => false)
    },
    getTopDownloadsWeekMods(success: any) {
        Ajax.get(ApiTopDownloadsWeek, {}, success, () => false)
    },
    addModVideo(data: {mod_id: number, video: string}, success: any, failure: any) {
        Ajax.put(ApiModVideo+'/'+data.mod_id, {video: data.video}, success, failure)
    },
    createModPost(data: any, success: any, failure: any) {
        axios.post(ApiCatalog, data, {
            headers: {'Content-Type': 'multipart/form-data'}
        })
        .then(response => {
            if(response.data["status"]) success(response.data)
            else {
                failure(response.data)
            }
        })
        .catch(error => {
            failure(error)
            throw error;
        })
    },
    updateModPost(data: any, success: any, failure: any) {
        data._method = 'put'
        axios.post(ApiCatalog+'/'+data.mod_id, data, {
            headers: {'Content-Type': 'multipart/form-data'}
        })
        .then(response => {
            if(response.data["status"]) success(response.data)
            else {
                failure(response.data)
            }
        })
        .catch(error => {
            failure(error)
            throw error;
        })
    }
}